export const toPaisa = (amount: number): number => Math.round(amount * 100)
export const fromPaisa = (paisa: number): number => paisa / 100
